import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import ProtectedRoute from "components/ProtectedRoute";
import NotFound from "pages/NotFound";
import LoginPage from "./pages/login";
import SignupPage from "./pages/signup";
import PartnerRegistrationDashboard from './pages/partner-registration-dashboard';
import PortfolioMappingInterface from './pages/portfolio-mapping-interface';
import PartnerEnablementCenter from './pages/partner-enablement-center';
import StrategicGrowthPlanning from './pages/strategic-growth-planning';
import EngagementManagementHub from './pages/engagement-management-hub';
import OpportunityProfilePage from './pages/engagement-management-hub/OpportunityProfilePage';
import ProjectProfilePage from './pages/engagement-management-hub/ProjectProfilePage';
import TenderProfilePage from './pages/engagement-management-hub/TenderProfilePage';
import GovernancePerformanceDashboard from './pages/governance-performance-dashboard';
import PartnerProfilePortal from './pages/partner-profile-portal';
import AllPartners from './pages/all-partners';
import AuditTrailPage from './pages/audit-trail';
import ReportingExportPage from './pages/reporting-export';
import ProductsCatalog from './pages/products-catalog';
import ServicesCatalog from './pages/services-catalog';
import ProductProfile from './pages/product-profile';
import CatalogDataQuality from './pages/catalog-data-quality';
import ServiceProfile from './pages/service-profile';
import BundlesCatalog from './pages/bundles-catalog';
import BundleProfile from './pages/bundle-profile';
import EngagementRecordsPage from './pages/engagement-records';
import ExecutiveDashboard from './pages/executive-dashboard';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/" element={<ProtectedRoute><ExecutiveDashboard /></ProtectedRoute>} />
        <Route path="/executive-dashboard" element={<ProtectedRoute><ExecutiveDashboard /></ProtectedRoute>} />
        <Route path="/partner-registration-dashboard" element={<ProtectedRoute><PartnerRegistrationDashboard /></ProtectedRoute>} />
        <Route path="/portfolio-mapping-interface" element={<ProtectedRoute><PortfolioMappingInterface /></ProtectedRoute>} />
        <Route path="/partner-enablement-center" element={<ProtectedRoute><PartnerEnablementCenter /></ProtectedRoute>} />
        <Route path="/strategic-growth-planning" element={<ProtectedRoute><StrategicGrowthPlanning /></ProtectedRoute>} />
        <Route path="/engagement-management-hub" element={<ProtectedRoute><EngagementManagementHub /></ProtectedRoute>} />
        <Route path="/engagement-management-hub/opportunity/:id" element={<ProtectedRoute><OpportunityProfilePage /></ProtectedRoute>} />
        <Route path="/engagement-management-hub/project/:id" element={<ProtectedRoute><ProjectProfilePage /></ProtectedRoute>} />
        <Route path="/engagement-management-hub/tender/:id" element={<ProtectedRoute><TenderProfilePage /></ProtectedRoute>} />
        <Route path="/engagement-records" element={<ProtectedRoute><EngagementRecordsPage /></ProtectedRoute>} />
        <Route path="/governance-performance-dashboard" element={<ProtectedRoute><GovernancePerformanceDashboard /></ProtectedRoute>} />
        <Route path="/partner-profile-portal" element={<ProtectedRoute><PartnerProfilePortal /></ProtectedRoute>} />
        <Route path="/partner-profile-portal/:partnerId" element={<ProtectedRoute><PartnerProfilePortal /></ProtectedRoute>} />
        <Route path="/all-partners" element={<ProtectedRoute><AllPartners /></ProtectedRoute>} />
        <Route path="/audit-trail" element={<ProtectedRoute><AuditTrailPage /></ProtectedRoute>} />
        <Route path="/reporting-export" element={<ProtectedRoute><ReportingExportPage /></ProtectedRoute>} />
        <Route path="/products-catalog" element={<ProtectedRoute><ProductsCatalog /></ProtectedRoute>} />
        <Route path="/products-catalog/:productId" element={<ProtectedRoute><ProductProfile /></ProtectedRoute>} />
        <Route path="/services-catalog" element={<ProtectedRoute><ServicesCatalog /></ProtectedRoute>} />
        <Route path="/services-catalog/:serviceId" element={<ProtectedRoute><ServiceProfile /></ProtectedRoute>} />
        <Route path="/bundles-catalog" element={<ProtectedRoute><BundlesCatalog /></ProtectedRoute>} />
        <Route path="/bundles-catalog/:bundleId" element={<ProtectedRoute><BundleProfile /></ProtectedRoute>} />
        <Route path="/catalog-data-quality" element={<ProtectedRoute><CatalogDataQuality /></ProtectedRoute>} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
